import { useProfileWidgetsHideContext } from '../useProfileWidgetsHideContext'

export function useIsProfileWidgetsHideAvailable() {
  return useProfileWidgetsHideContext() !== null
}
